import { atomWithStorage } from "jotai/utils";

/** Role id the person picked from `/me/access` `roles[]`; null is the default. */
export const selectedAccessRoleIdAtom = atomWithStorage<string | null>(
  "MEQ-access-role",
  null,
  undefined,
  { getOnInit: true },
);
